import {configureStore} from "@reduxjs/toolkit";
import application from './slices/ApplicationSlice';
import category from './slices/CategorySlice';
import contractCreate from './slices/ContractCreateSlice';
import course from './slices/CourseSlice';
import categoriesList from './slices/CategoriesListSlice';
import studentsListForOrder from './slices/StudentListForOrderSlice';
import teachersListForOrder from './slices/TeachersListForOrderSlice';
import groupStudentsListForOrder from './slices/GroupStudentListForOrderSlice';
import realGroupsForOrder from './slices/RealGroupsForOrderSlice';
import contractCategoriesList from './slices/ContractCategoriesListSlice';
import contractList from './slices/ContractListSlice';
import globalValueList from './slices/GlobalValueListSlice';
import applicationsList from './slices/ApplicationsListSlice';
import usersList from './slices/UsersListSlice';
import applicationsListTableController from './slices/tableController/ApplicationsListTableController';
import usersListTableController from './slices/tableController/UsersListTableController';
import contractListTableController from './slices/tableController/ContractListTableControllerSlice';
import user from './slices/userSlice';
import studentsList from "./slices/StudentsListSlice";
import teachersList from "./slices/TeachersListSlice";
import mEditorsList from "./slices/MEditorsListSlice";
import platformNav from './slices/platform/PlatformNavSlice';
import formSave from './slices/FormSaveSlice';
import form from './slices/FormSlice';
import formsList from './slices/FormsListSlice';
import teacherGroup from './slices/TeacherGroupSlice';
import certificateList from './slices/CertificateSlice';
import aetResultList from './slices/AetResultsSlice';
import journalList from './slices/JournalSlice';
import microQualificationList from './slices/MicroqualificationsSlice';
import educationFieldList from './slices/EducationFieldsSlice';
import trainingDirectionList from './slices/TrainingDirectionsSlice';
import groupEPList from './slices/GroupEpsSlice';
import partnerOrganizationList from './slices/PartnerOrganizationsSlice';
import profStandardsList from './slices/ProfessionalStandardsSlice';
import microQualification from './slices/MicroqualificationSaveSlice';
import counterDocs from './slices/CounterSlice';
import certificatesListTableController from "./slices/tableController/CertificatesListTableController";
import certificatesUnsignedListTableController from "./slices/tableController/CertificatesUnsignedListTableController";
import journalsListTableController from "./slices/tableController/JournalsListTableController";
import microQualificationListTableController from "./slices/tableController/MicroQualificationListTableController";
import educationFieldListTableController from "./slices/tableController/EducationFieldListTableController";
import trainingDirectionListTableController from "./slices/tableController/TrainingDirectionListTableController";
import groupEpListTableController from "./slices/tableController/GroupEpListTableController";
import partnerOrgListTableController from "./slices/tableController/PartnerOrgListTableController";
import profStandardsListTableController from "./slices/tableController/ProfStandardsListTableController";
import studentsListTableController from "./slices/tableController/StudentsListTableController";
import teachersListTableController from "./slices/tableController/TeachersListTableController";
import mEditorsListTableController from "./slices/tableController/MEditorsListTableController";
import actCompletionWorkList from "./slices/ActCompletionWorkSlice";
import actCompletionWorkTableController from "./slices/tableController/ActCompletionWorkTableControllerSlice";
import microqualificationGroups from "./slices/MicroqualificationGroupsSlice";
import microqualificationGroupsListTableController from "./slices/tableController/MicroqualificationGroupsListTableController";
import coursesCatalog from "./slices/CoursesCatalogSlice";
import marketCourses from "./slices/MarketCoursesSlice";

export default configureStore({
    reducer: {
        coursesCatalog: coursesCatalog,
        marketCourses: marketCourses,
        application: application,
        category: category,
        contractCreate: contractCreate,
        course: course,
        categoriesList: categoriesList,
        studentsListForOrder: studentsListForOrder,
        teachersListForOrder: teachersListForOrder,
        groupStudentsListForOrder: groupStudentsListForOrder,
        realGroupsForOrder: realGroupsForOrder,
        contractCategoriesList: contractCategoriesList,
        contractList: contractList,
        globalValueList: globalValueList,
        applicationsList: applicationsList,
        usersList: usersList,
        studentsList: studentsList,
        teachersList: teachersList,
        mEditorsList: mEditorsList,
        applicationsListTableController: applicationsListTableController,
        usersListTableController: usersListTableController,
        contractListTableController: contractListTableController,
        certificatesListTableController: certificatesListTableController,
        certificatesUnsignedListTableController: certificatesUnsignedListTableController,
        journalsListTableController: journalsListTableController,
        microQualificationListTableController: microQualificationListTableController,
        educationFieldListTableController: educationFieldListTableController,
        trainingDirectionListTableController: trainingDirectionListTableController,
        groupEpListTableController: groupEpListTableController,
        partnerOrgListTableController: partnerOrgListTableController,
        profStandardsListTableController: profStandardsListTableController,
        studentsListTableController: studentsListTableController,
        teachersListTableController: teachersListTableController,
        mEditorsListTableController: mEditorsListTableController,
        user: user,
        platformNav: platformNav,
        formSave: formSave,
        form: form,
        formsList: formsList,
        teacherGroup: teacherGroup,
        certificateList: certificateList,
        aetResultList: aetResultList,
        journalList: journalList,
        microQualificationList: microQualificationList,
        educationFieldList: educationFieldList,
        trainingDirectionList: trainingDirectionList,
        groupEPList: groupEPList,
        partnerOrganizationList: partnerOrganizationList,
        profStandardsList: profStandardsList,
        microQualification: microQualification,
        counterDocs: counterDocs,
        actCompletionWorkList: actCompletionWorkList,
        actCompletionWorkTableController: actCompletionWorkTableController,
        microqualificationGroups: microqualificationGroups,
        microqualificationGroupsListTableController: microqualificationGroupsListTableController
    },
});